export default class Login {
  constructor(email, password) {
    this.email = email;
    this.password = password
  }
}
